import styled, { css } from 'styled-components';
import { FormContainerFieldSetContainer } from '../../form-container-field-set';
import { PanelContainer } from '../../panel';
import Spinner, { SpinnerText } from '../../spinner';
import { pxToRem } from '../../../design-tokens/style-utilities';
const SPINNER_TOP = '35%';
export const formContainerStyles = ({ theme, $isHorizontal, $isLoading, }) => css `
	label {
		display: block;
		width: auto;
	}

	legend ~ label {
		margin: ${pxToRem(theme.spacing['100'])} 0;
	}

	[data-variant='label-title'] {
		margin: 0 0 ${pxToRem(theme.spacing['100'])} 0;
	}

	[data-variant='field-validation'] {
		margin-top: ${pxToRem(theme.spacing['100'])};
	}

	${PanelContainer} {
		padding: 0;
		margin: ${pxToRem(theme.spacing['100'])} 0;

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			margin: ${pxToRem(theme.spacing['300'])} 0;
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
			margin: ${pxToRem(theme.spacing['400'])} 0;
		}

		&:first-of-type {
			margin-top: 0;
		}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		fieldset {
			width: auto;
			max-width: ${pxToRem(theme.viewportBreakpoint.sm)};
		}
	}

	${$isHorizontal &&
    css `
		fieldset {
			max-width: inherit !important;
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			${FormContainerFieldSetContainer} {
				align-items: flex-start;
			}

			& label {
				overflow: hidden;
				max-height: ${pxToRem(theme.typography.heading7['75LabelTitle'].lineHeight)};
			}
		}
	`}

	${$isLoading &&
    css `
		position: relative;
		user-select: none;
		pointer-events: none;

		& > * {
			transition: opacity 0.2s;
			opacity: 0.3;
		}
	`}
`;
export const FormContainer = styled.form `
	${formContainerStyles}
`;
/**
 * Form Header component
 */
export const formHeaderStyles = ({ theme }) => css `
	position: sticky;
	top: 0;
	z-index: ${theme.zIndex.sticky};
	width: auto;
	max-width: none;
	margin-bottom: ${pxToRem(Number(theme.spacing['100']) / 2)};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.blanc.bgSite};

	&:empty {
		margin: 0;
	}
`;
export const FormHeader = styled.header `
	${formHeaderStyles}
`;
/**
 * Form Spinner
 */
export const formSpinnerStyles = () => css `
	opacity: 1;
	position: absolute;
	top: ${SPINNER_TOP};
	left: 50%;
	transform: translateX(-50%);

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const FormSpinner = styled(Spinner) `
	${formSpinnerStyles}
`;
/**
 * The class name "PONCHO-form__inline" is not used by any components in this package but is used by other applications.
 * To still provide the styling this style definition can be used.
 */
export const formInlineStyles = ({ theme }) => css `
	display: flex;
	flex-flow: row wrap;
	margin: 0;
	width: calc(100% - ${pxToRem(theme.spacing['100'])});
	max-width: none;

	& label {
		margin: ${pxToRem(theme.spacing['100'])} 0;

		&:not(:last-child) {
			margin-right: ${pxToRem(theme.spacing['300'])};
		}
	}
`;
